export * from './lib/animal-selection-animals.module';
export { AnimalSelectionAnimalsComponent } from './lib/animal-selection-animals.component';
